const wrapper = "_vcw1hogpm2";
const iconButton = "_vciopell3";
const progressText = "_vcp1p70d0x";
const loader = "_vcldgto68";

export { iconButton, loader, progressText, wrapper };
import "./molecule.controls.style.linaria.module.css";
//# sourceMappingURL=molecule.controls.style.js.map
